//  document.addEventListener("DOMContentLoaded", function() {
//   var thumbSwiper = new Swiper(".custom-featured-product .thumbSwiper", {
//     spaceBetween: 25,
//     slidesPerView: 5,
//     watchSlidesProgress: true,
//     loop: false, 
//     navigation: {
//       nextEl: ".custom-featured-product .thumbSwiper .swiper-button-next",
//       prevEl: ".custom-featured-product .thumbSwiper .swiper-button-prev",
//     },
//     breakpoints: {
//       769: { 
//         direction: "horizontal",
//       },
//       481: { 
//         direction: "horizontal",
//       },
// 0: { 
//           slidesPerView: 4,
//            spaceBetween: 12,
//       }
//     }
//   });

//   var featuredSwiper = new Swiper(".custom-featured-product .featuredSwiper", {
//     spaceBetween: 1,
//     slidesPerView: 1,
//     navigation: {
//       nextEl: ".custom-featured-product .featuredSwiper .swiper-button-next",
//       prevEl: ".custom-featured-product .featuredSwiper .swiper-button-prev",
//     },
//     thumbs: {
//       swiper: thumbSwiper,
//     },
//   });
// });

document.addEventListener("DOMContentLoaded", function() {
  // Initialize Swipers
  var thumbSwiper = new Swiper(".custom-featured-product .thumbSwiper", {
    spaceBetween: 25,
    slidesPerView: 5,
    watchSlidesProgress: true,
    loop: false, 
    navigation: {
      nextEl: ".custom-featured-product .thumbSwiper .swiper-button-next",
      prevEl: ".custom-featured-product .thumbSwiper .swiper-button-prev",
    },
    breakpoints: {
      769: { direction: "horizontal" },
      481: { direction: "horizontal" },
      0: { slidesPerView: 4, spaceBetween: 12 }
    }
  });

  var featuredSwiper = new Swiper(".custom-featured-product .featuredSwiper", {
    spaceBetween: 1,
    slidesPerView: 1,
    navigation: {
      nextEl: ".custom-featured-product .featuredSwiper .swiper-button-next",
      prevEl: ".custom-featured-product .featuredSwiper .swiper-button-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });

  // Desktop Thumbnails Click
  var desktopThumbnails = document.querySelectorAll(".pdp_main_product .desktop_thumbnails_image .images_thumnal");

  desktopThumbnails.forEach(function(thumbnail, index) {
    thumbnail.addEventListener("click", function() {
      // Slide main Swiper to clicked index
      featuredSwiper.slideTo(index);

      // Remove active class from all
      desktopThumbnails.forEach(function(el) {
        el.classList.remove("active");
      });

      // Add active class to clicked thumbnail
      thumbnail.classList.add("active");
    });
  });

  // Optional: Set first thumbnail as active initially
  if (desktopThumbnails.length > 0) {
    desktopThumbnails[0].classList.add("active");
  }
});



$(document).ready(function(){
     $(".custom-featured-product .faq_accordion .faq_warp").click(function(e){
         e.preventDefault();
         $(this).find(".answerrr").slideToggle('fast');
         $(this).find(".question_wrap svg").toggleClass("rotate__180");

     })
 

})


  function updatingCart() {

    $('cart-drawer.drawer').load(location.href + ' cart-drawer.drawer > *');
$(' div#CartDrawer').load(location.href + ' div#CartDrawer > *');
       $('.cart-items').load(location.href + ' .cart-items > *'); 
  $('.drawer__cart-items-wrapper').load(location.href + ' .drawer__cart-items-wrapper > *'); 
        $('cart-drawer').load(location.href + ' cart-drawer > *');
 
            // $.get('/?sections=cart-drawer', function (thedata) {
            
            //     let updatedHtml = thedata['cart-drawer'];
            //     $('cart-drawer-items').removeClass(" is-empty");



            //     let $newUpdatedHtml = $('<div>').html(updatedHtml);         
        
            //     let $newItems = $newUpdatedHtml.find('cart-drawer-items').html();
            //     let $newSubtotal = $newUpdatedHtml.find('.totals__total-value').html();
              
            //     $('cart-drawer-items').html($newItems);
         
            //     $('.totals__total-value').html($newSubtotal);
            // });
        }

$(".custom-featured-product .product.grid .grid__item.product__info-wrapper .product-form__buttons .product-form__submit").click(function(){
   
   updatingCart();
   $('cart-drawer').addClass("active");

})

$(document).on('click', '.subscription_check', function () {
    $('.subscription_check input').prop('checked', false);
    
    $(this).find('input').prop('checked', true);
   
    var name_value = $(this).attr('name_val');
   
    var plan_id = $(this).attr('plan_id');
   
    console.log(name_value);
   
    if(name_value == 'subscription plan'){
        $('.selling_plan_ids').val(plan_id);
        $(".custom-featured-product .js-qty__num").val("1");
    } else if(name_value == 'one time'){
        $('.selling_plan_ids').val('');
        $(".custom-featured-product .js-qty__num").val("1");
        
    } else {
       $('.selling_plan_ids').val('');
       $(".custom-featured-product .js-qty__num").val("3");
    }
});

$(document).on("click", "#CartDrawer-Overlay", function(){
  $("cart-drawer.drawer ").removeClass("active");

})